import Badge from "../ui/Badge.jsx";

const STATUS_VARIANT = {
  active: "healthy",
  suspended: "warning",
  deactivated: "archived",
  deleted: "critical",
};

function labelFor(status) {
  const s = String(status || "").toLowerCase();
  if (s === "active") return "Active";
  if (s === "suspended") return "Suspended";
  if (s === "deactivated") return "Deactivated";
  if (s === "deleted") return "Deleted";
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "Unknown";
}

export default function StatusBadge({ status }) {
  const key = String(status || "").toLowerCase();
  const variant = STATUS_VARIANT[key] || "info";
  return <Badge variant={variant}>{labelFor(key)}</Badge>;
}
